import type { FaireProductEntity } from "../../entity_types/product";

export const p_zfekraekak: FaireProductEntity = {
  token: "p_zfekraekak",
  type: "product",
  name: "Glossy U-shaped Hollow 18K Gold Plated SS Hoop Earrings -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/b2a7608c97db35a91587a027ca6d0832dbb4ef13a093494fa21a44c22bce7e42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c732da76ad5112df26c709465fe1aaf12d48c8db64a7e11a0c2d2d086678d933.jpeg",
    "https://cdn.faire.com/fastly/f7aa478105d5a895d7e76fa96ef3be0a637d35db9ff00663fcfb87d0554f28a4.jpeg",
    "https://cdn.faire.com/fastly/9f04cede04bea7bf8dd1743f1a26e34b06382a8a2b65ffd329e6628071ad8747.jpeg"
  ],
  priceDollars: 7.58,
  description: "Type: earrings\n\nMaterial : 316L Stainless steel ，18K gold plated\n\nSize ： 20mm *25mm\n\nProcess: Vacuum electroplating and manual polishing,Non tarnish\n\nSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 17.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:55.211Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
